(function () {

	const productInfo = () => {
		let swiper
		const pageInfoLeft = document.querySelector('.product-info__left');

		const initSwiper = () => {
			swiper = new Swiper(pageInfoLeft, {
				// 다양한 옵션 설정, 
				// 아래에서 설명하는 옵션들은 해당 위치에 들어갑니다!!
				slidesPerView : 1,
				pagination: {
					el: ".product-info__progress",
					type: "progressbar",
				},
			})
		}
    
		const swiperCheck = () => {
			// 모바일 에서 swiper 작용
			if (window.innerWidth <= 750) {
				if(!swiper) {
					initSwiper();
				}
			} else {
				if (swiper) {
					swiper.destroy(true, true);
					swiper = null
				}
			}
		}

		
		// 용량 선택시 스와이퍼 재설정
		const changeSwiper = () => {
			if (swiper) {
				swiper.destroy(true, true);
				swiper = null
			}
			swiperCheck()
		};
		const obSwiper = new MutationObserver(() => {
			obSwiper.disconnect();
			changeSwiper();
			obSwiper.observe(pageInfoLeft, {
				childList: true,
				subtree: true,
			})
		});
		obSwiper.observe(pageInfoLeft, {
			childList: true,
			subtree: true,
		})
		// 페이지 로드, 리사이즈시 swiper 체크
		window.addEventListener('load', () => {
			swiperCheck();
		});	
		window.addEventListener('resize', swiperCheck);
	}

	productInfo();
	document.addEventListener('shopify:section:load', productInfo);

	// fera 감지로 lenis resize
	const feraResize = {
		element: document.querySelector('[data-fera-container].fera-widget-container'),
		// activeClass: 'section-active',
		options: {
			threshold: [0], // 반응범위(0.0 = 제일윗부분 ~ 1.0 = 제일 끝부분 / ex: 0.5 = 감시객체의 절반이 화면에 등장할때 감시)
			rootMargin: '200% 0px'
		},
		init: function () {
			// 초기 세팅값
			const element = this.element;
		
			element && this.feraObserver();
		},
		feraObserver: function () {
			const element = this.element;
			const options = this.options;
		
			const scrollObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					scrollSet.lenisResize();
				});
			}, options);
		
			scrollObserver.observe(element);
		},
	};

	// feraResize.init();

})();
